'use strict';
module.exports = require('./PrimeVue.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/config/index.js
// module id = 467
// module chunks = 7